<template>
    <div class="audit-log-page">
        <van-nav-bar title="审核记录" left-text="返回" @click-left="back" fixed left-arrow />
        <div class="page-body">
            <van-list
                v-model="loading"
                :finished="finished"
                finished-text="没有更多了"
                :error.sync="error"
                error-text="请求失败，点击重试"
                @load="loadMore"
            >
                <div v-for="item in list" :key="item.id" class="audit-card">
                    <div class="card-header">
                        <div class="operator">
                            <span class="role-label">审核人</span>
                            <span v-if="user.userNameNeedTranslate == '1'">
                                <TranslationOpenDataText type="userName" :openid="item.userName"></TranslationOpenDataText>
                            </span>
                            <span v-else>{{ item.userName || '-' }}</span>
                        </div>
                        <div class="result" :class="resultClass(item)">{{ shortResult(item.result) }}</div>
                    </div>
                    <div class="card-row">
                        <span class="label">审核时间</span>
                        <span class="value">{{ formatIndate(item.indate) }}</span>
                    </div>
                    <div class="card-row" v-if="item.projectName">
                        <span class="label">项目</span>
                        <span class="value">{{ item.projectName }}</span>
                    </div>
                    <div class="card-row">
                        <span class="label">审核结果</span>
                        <span class="value result-text">{{ item.result || '-' }}</span>
                    </div>
                    <div class="memb-block" v-if="item.membdateList && item.membdateList.length">
                        <div class="memb-title">填报人 / 工作日期（{{ item.membdateList.length }}）</div>
                        <div
                            class="memb-item"
                            v-for="(m, idx) in visibleMembList(item)"
                            :key="m.id || idx"
                        >
                            <div class="memb-main">
                                <span class="role-label soft">填报人</span>
                                <span v-if="user.userNameNeedTranslate == '1'">
                                    <TranslationOpenDataText type="userName" :openid="m.userName"></TranslationOpenDataText>
                                </span>
                                <span v-else>{{ m.userName || '-' }}</span>
                                <span class="memb-date">{{ m.createDate || '-' }}</span>
                            </div>
                            <div class="memb-state" :class="'state-' + m.state">{{ stateText(m.state) }}</div>
                        </div>
                        <div
                            class="memb-more"
                            v-if="item.membdateList.length > 3"
                            @click="toggleExpand(item)"
                        >
                            {{ item._expanded ? '收起' : '展开全部 ' + item.membdateList.length + ' 条' }}
                        </div>
                    </div>
                    <div class="memb-block empty" v-else>暂无填报人明细</div>
                </div>
                <van-empty v-if="!loading && list.length === 0" description="暂无审核记录" />
            </van-list>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            user: JSON.parse(localStorage.userInfo || '{}'),
            list: [],
            pageIndex: 1,
            pageSize: 20,
            total: 0,
            loading: false,
            finished: false,
            error: false
        };
    },
    methods: {
        back() {
            history.back();
        },
        formatIndate(val) {
            if (!val) return '-';
            if (typeof val === 'string') {
                return val.length > 16 ? val.substring(0, 16) : val;
            }
            return val;
        },
        shortResult(result) {
            if (!result) return '-';
            if (result.indexOf('通过') > -1) return '已通过';
            if (result.indexOf('驳回') > -1) return '已驳回';
            if (result.indexOf('撤销') > -1) return '已撤销';
            return result.length > 8 ? result.substring(0, 8) + '…' : result;
        },
        resultClass(item) {
            const r = item.result || '';
            if (r.indexOf('通过') > -1) return 'pass';
            if (r.indexOf('驳回') > -1) return 'reject';
            if (r.indexOf('撤销') > -1) return 'undo';
            return '';
        },
        stateText(state) {
            if (state === 1) return '已通过';
            if (state === 2) return '已驳回';
            if (state === 3) return '已撤销';
            return '未知';
        },
        visibleMembList(item) {
            const list = item.membdateList || [];
            if (item._expanded || list.length <= 3) return list;
            return list.slice(0, 3);
        },
        toggleExpand(item) {
            this.$set(item, '_expanded', !item._expanded);
        },
        loadMore() {
            this.fetchList(false);
        },
        fetchList(reset) {
            if (reset) {
                this.pageIndex = 1;
                this.list = [];
                this.finished = false;
                this.error = false;
            }
            this.loading = true;
            this.$axios
                .post('/report-audit-log/getProjectReportAuditLog', {
                    companyId: this.user.companyId,
                    pageIndex: this.pageIndex,
                    pageSize: this.pageSize
                })
                .then(res => {
                    this.loading = false;
                    if (res.code === 'ok' || res.code == 'ok') {
                        const records = (res.data && res.data.records) || [];
                        const total = (res.data && res.data.total) || 0;
                        this.total = total;
                        records.forEach(r => {
                            this.$set(r, '_expanded', false);
                        });
                        this.list = this.list.concat(records);
                        if (this.list.length >= total || records.length < this.pageSize) {
                            this.finished = true;
                        } else {
                            this.pageIndex += 1;
                        }
                    } else {
                        this.error = true;
                        this.finished = true;
                        this.$toast.fail(res.msg || '加载失败');
                    }
                })
                .catch(() => {
                    this.loading = false;
                    this.error = true;
                    this.finished = true;
                });
        }
    }
};
</script>

<style lang="less" scoped>
.audit-log-page {
    min-height: 100vh;
    background: #f5f6f8;
}
.page-body {
    padding: 56px 12px 20px;
}
.audit-card {
    background: #fff;
    border-radius: 10px;
    padding: 12px 14px;
    margin-bottom: 12px;
    box-shadow: 0 1px 4px rgba(0, 0, 0, 0.04);
}
.card-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 10px;
    padding-bottom: 8px;
    border-bottom: 1px solid #f0f0f0;
}
.operator {
    font-size: 15px;
    font-weight: 600;
    color: #323233;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
}
.role-label {
    display: inline-block;
    font-size: 12px;
    font-weight: 500;
    color: #1989fa;
    background: #e8f3ff;
    border-radius: 3px;
    padding: 1px 6px;
    margin-right: 6px;
    line-height: 1.4;
    &.soft {
        color: #646566;
        background: #f2f3f5;
        font-weight: 400;
    }
}
.result {
    font-size: 13px;
    padding: 2px 8px;
    border-radius: 4px;
    background: #f2f3f5;
    color: #646566;
    &.pass {
        background: #e8f8ef;
        color: #07c160;
    }
    &.reject {
        background: #fdeeee;
        color: #ee0a24;
    }
    &.undo {
        background: #fff7e6;
        color: #ed6a0c;
    }
}
.card-row {
    display: flex;
    font-size: 13px;
    line-height: 1.7;
    margin-bottom: 4px;
    .label {
        color: #969799;
        min-width: 64px;
        flex-shrink: 0;
    }
    .value {
        color: #323233;
        word-break: break-all;
    }
    .result-text {
        color: #646566;
    }
}
.memb-block {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px dashed #ebedf0;
    &.empty {
        font-size: 12px;
        color: #c8c9cc;
    }
}
.memb-title {
    font-size: 12px;
    color: #969799;
    margin-bottom: 6px;
}
.memb-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 13px;
    padding: 6px 0;
    border-bottom: 1px solid #f7f8fa;
    &:last-child {
        border-bottom: none;
    }
}
.memb-main {
    color: #323233;
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    .memb-date {
        margin-left: 8px;
        color: #969799;
    }
}
.memb-state {
    font-size: 12px;
    &.state-1 {
        color: #07c160;
    }
    &.state-2 {
        color: #ee0a24;
    }
    &.state-3 {
        color: #ed6a0c;
    }
}
.memb-more {
    text-align: center;
    color: #1989fa;
    font-size: 13px;
    padding: 8px 0 2px;
}
</style>
<style lang="less">
.audit-log-page {
    .van-nav-bar .van-icon,
    .van-nav-bar__text {
        color: #20a0ff;
    }
}
</style>
